// @flow
import { redirectTo } from '../generalCreators';
import type { ThunkAction } from '../../types';

export function displayAuthenticationError(): ThunkAction {
  return function(dispatch) {
    redirectTo('/');
    // temporarily display an access error message
    dispatch({ type: 'UNAUTHORISED_GLOBAL_ACCESS' });
    setTimeout(() => dispatch(clearAccessError()), 5000);
  };
}

export function clearAccessError(): ThunkAction {
  return function(dispatch) {
    dispatch({ type: 'CLEAR_ACCESS_ERROR' });
  };
}



// WEBPACK FOOTER //
// ./src/actions/authentication/basicCreators.js